import { AxiosInstance } from 'axios';
import {
	GetPricesAndFeesDto,
	CreatePaymentIntentDto,
	OrdersForDashboardDto,
	OrdersFilter,
	CreatePaymentIntent,
	GetEventPricesAndFeesRequestDto,
	OrderDto,
	EventTicketDto,
	PublicCreatePaymentIntentV2,
	GetPricesAndFeesRequestDtoV2,
	CreatePaymentIntentV2,
	TicketWithoutPaymentDetailsDto,
	EventTicketsPublicFilter,
	GetPricesAndFeesToUpgradeTicketRequestDtoV2,
	ShortOrdersFilter,
} from '@sweatpals/shared';
import { DASHBOARD_URL } from '../constants';
import { httpClient } from './http-factory';

export class PaymentService {
	constructor(private readonly httpClient: AxiosInstance) {}

	public async getPrices(body: GetPricesAndFeesRequestDtoV2): Promise<GetPricesAndFeesDto> {
		const { data } = await httpClient.post(`/payments/v2/pricesAndFees`, body);

		return data;
	}

	public async getPublicPrices(body: GetPricesAndFeesRequestDtoV2): Promise<GetPricesAndFeesDto> {
		const { data } = await httpClient.post(`/payments/v2/public/pricesAndFees`, body);

		return data;
	}

	public async getPublicPricesAndFeesToUpgradeTicketV2(
		body: GetPricesAndFeesToUpgradeTicketRequestDtoV2
	): Promise<GetPricesAndFeesDto> {
		const { data } = await httpClient.post(`/payments/v2/public/pricesAndFees/upgrade-ticket`, body);

		return data;
	}

	public async getAccountLink(userId?: string): Promise<{ url: string }> {
		const { data } = await httpClient.post(`/payments/account-link`, {
			returnUrl: `${DASHBOARD_URL}/wallet`,
			refreshUrl: `${DASHBOARD_URL}/wallet?closeTabOnSuccess=true`,
			userId,
		});

		return data;
	}

	public async getOrdersForDashboard(filter?: OrdersFilter): Promise<OrdersForDashboardDto> {
		const { data } = await httpClient.post(`/payments/orders/dashboard`, filter);

		return data;
	}

	public async getOrderByIdOrPaymentIntentId(id: string, filters?: ShortOrdersFilter): Promise<OrderDto> {
		const { data } = await httpClient.get(`/payments/order/${id}`, {
			params: filters,
		});

		return data;
	}

	public async getPublicTicketsByEmail(ticketsPublicFilter: EventTicketsPublicFilter): Promise<TicketWithoutPaymentDetailsDto[]> {
		const { data } = await this.httpClient.post<TicketWithoutPaymentDetailsDto[]>(
			`/payments/public/tickets/by-email`,
			ticketsPublicFilter,
		);

		return data;
	}

	public async getPublicTicketById(ticketId: string): Promise<EventTicketDto> {
		const { data } = await httpClient.get(`/payments/ticket/${ticketId}`);

		return data;
	}

	public async getOrders(filter?: OrdersFilter): Promise<OrderDto[]> {
		const { data } = await httpClient.get(`/payments/orders`, { params: filter });

		return data;
	}

	public async createPaymentIntent(body: CreatePaymentIntent): Promise<CreatePaymentIntentDto> {
		const { data } = await httpClient.post(`/payments/event/payment-intent`, body);

		return data;
	}

	public async createPublicPaymentIntentV2(
		body: PublicCreatePaymentIntentV2
	): Promise<(CreatePaymentIntentDto & { verificationCodeRequired?: boolean }) | null> {
		const { data } = await httpClient.post(`/payments/v2/public/payment-intent`, body);

		return data;
	}

	public async createPublicPaymentIntentToUpgradeTicketV2(
		body: GetPricesAndFeesToUpgradeTicketRequestDtoV2
	): Promise<CreatePaymentIntentDto | null> {
		const { data } = await httpClient.post(`/payments/v2/public/payment-intent/upgrade-ticket`, body);

		return data;
	}

	public async createPaymentIntentV2(body: CreatePaymentIntentV2): Promise<CreatePaymentIntentDto> {
		const { data } = await httpClient.post(`/payments/v2/payment-intent`, body);

		return data;
	}
}
